import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Button, TextField, MenuItem, Grid, IconButton, Typography, Paper, AppBar, Toolbar, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import {observable, action} from 'mobx';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import {DatePicker, Day} from "material-ui-pickers"
import 'moment/locale/cs';
import DenStore from 'src/stores/DenStore'
import Den from 'src/models/Den'
import CiselnikyStore from 'src/stores/CiselnikyStore';

export interface IClientDaysProps {
    denStore?: DenStore;
    klientId: number;
    ciselnikyStore?: CiselnikyStore;
}

@inject('denStore')
@inject('ciselnikyStore')
@observer
export class ClientDaysSection extends React.Component<IClientDaysProps> {

    @observable private klientId: number;

    constructor(props: Readonly<IClientDaysProps>) {
        super(props);
        this.klientId = props.klientId;
        this.props.denStore.loadForClient(this.props.klientId);
    }

    @observable private isNewDayDialogOpen: boolean = false;
    @observable private isDeleteDialogOpen: boolean = false;
    @observable private denEdit: Den = new Den();
    @observable private denToDelete: Den = new Den();

    @action
    private onNewDayDialogClose = () => {
        this.isNewDayDialogOpen = !this.isNewDayDialogOpen;
    }

    @action
    private onSaveNewDen = event => {
        this.isNewDayDialogOpen = !this.isNewDayDialogOpen;
        this.props.denStore.createNewDen(this.props.klientId, this.denEdit.datum, this.denEdit.typ);
    }

    @action
    private handleEntityDateValueChange = (entity,name) => date => {
        entity[name] = moment(date).toDate();
    }

    @action
    private handleEntityValueChange = (entity,name) => event => {
        entity[name] = event.target.value;
    }

    private handleAddDenClick = event => {
        this.denEdit = new Den();
        this.denEdit.datum = new Date();
        this.denEdit.typ = 'odhlaseny';
        this.isNewDayDialogOpen = true;
    }

    @action
    private handleDenDeleteClick = den => evt => {
        this.denToDelete = den;
        this.isDeleteDialogOpen = true;
    }

    private handleDeleteDialogOK = event => {
        this.props.denStore.deleteDen(this.denToDelete)
            .then(den => {
                this.denToDelete = undefined;
                this.isDeleteDialogOpen = !this.isDeleteDialogOpen;
            });
    }

    @action
    private onCloseDeleteDialog = event => {
        this.isDeleteDialogOpen = !this.isDeleteDialogOpen;
    }

    public render() {
        return (
        <div>
            <Paper square >
                <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#90a4ae'}}>
                    <Toolbar variant="dense">
                    <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                        Dny
                    </Typography>
                    <IconButton color="inherit" aria-label="Add" onClick={this.handleAddDenClick}>
                        <AddIcon />
                    </IconButton>
                    </Toolbar>
                </AppBar>
                <Grid container spacing={8}>
                    <Grid item style={{ marginLeft: 8, marginTop: 10 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Datum</TableCell>
                                    <TableCell>Typ</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    this.props.denStore.days.map(den => (
                                        <TableRow hover key={den.idKlient + den.datum.toLocaleDateString()}>
                                            <TableCell>{den.datum.toLocaleDateString()}</TableCell>
                                            <TableCell>{den.typ === 'odhlaseny' ? 'Odhlášený' : 'Náhrada'}</TableCell>
                                                <TableCell>
                                                    <IconButton color="inherit" aria-label="Delete" onClick={this.handleDenDeleteClick(den)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </Paper>
            <Dialog
                open={this.isNewDayDialogOpen}
                onClose={this.onNewDayDialogClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Nový den</DialogTitle>
                <DialogContent>
                        <Grid container spacing={8}>
                            <Grid item>
                                <DatePicker label="Počáteční datum" value={this.denEdit.datum} onChange={this.handleEntityDateValueChange(this.denEdit, 'datum')}/>
                            </Grid>
                            <Grid item>
                                <TextField label="Typ" id="new-den-typ" select onChange={this.handleEntityValueChange(this.denEdit, 'typ')} 
                                    value={this.denEdit.typ}>
                                        <MenuItem value="odhlaseny">Odhlášení</MenuItem>
                                        <MenuItem value="nahrada">Náhrada</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField label="Program" id="new-den-program" select onChange={this.handleEntityValueChange(this.denEdit, 'program')} 
                                    value={this.denEdit.program}>
                                        <MenuItem value="none" >Žádný</MenuItem>
                                        {this.props.ciselnikyStore.getAllValidPrograms().map(prg => (
                                            <MenuItem value={prg.value}>{prg.value} kJ ({prg.price} Kč/den)</MenuItem>
                                        ))}
                                </TextField>
                            </Grid>
                        </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onNewDayDialogClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.onSaveNewDen} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={this.isDeleteDialogOpen}
                onClose={this.onCloseDeleteDialog}
                aria-labelledby="delete-confirm-dialog">
                <DialogTitle id="delete-confirm-dialog">Smazat</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Opravdu smazat?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onCloseDeleteDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.handleDeleteDialogOK} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ClientDaysSection.tsx